import ReactModal from 'react-modal';

interface ImageModalProps {
  isOpen: boolean;
  src: string | null;
  alt?: string;
  onClose: () => void;
}

export const ImageModal: React.FC<ImageModalProps> = ({
  isOpen = false,
  src,
  alt,
  onClose
}) => {
  if (!src) return <></>;
  return (
    <ReactModal
      isOpen={isOpen}
      shouldCloseOnOverlayClick={true}
      onRequestClose={onClose}
    >
      <div
        className="fixed inset-0 z-50 flex items-center justify-center"
        onClick={onClose}
      >
        <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" />

        <img
          src={src}
          alt={alt}
          className="relative max-h-[90vh] max-w-[90vw] rounded-xl shadow-xl"
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    </ReactModal>
  );
};
